import React, { useState, useEffect, useContext, createContext } from 'react';
import { useRef } from 'react';

import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';
import ReactToPrint from 'react-to-print';
import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button, Divider, Switch } from 'antd';
import print from '../../../components/print/print';
import toast from 'react-hot-toast';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import Exchange from './exchange';





function PayCashModal(props) {

  let { showModal, toggleModal, closePos, title, totalPrice, transactions, totalDiscounts,
    selectedTab, selectedCurrency, isPrinting, jvCost, jvProfit, jvId, refreshTableFunction, auxAccountData, ratedTotalPrice, ratedSymbol, totalVatAmount } = props;

  const { tabData, setCart, resetJournalVoucher, setJournalVoucher } = useContext(PosCartContext);

  const { userData, rateMainToSecondaryCurrency, rateToMainCurrency, settingData, sessionId, mainCurrency,
    serverApi, localApi, devData, customerAccountData, deliveryData, companyData } = useContext(DataContext);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [details, setDetails] = useState('');
  const [saveCustomerPrice, setSaveCustomerPrice] = useState(false);

  const today = new Date().toISOString().split('T')[0];
  const isUsingMainCurrency = selectedCurrency.id == mainCurrency.id ? true : false;

  const isEdit = tabData[selectedTab]?.isEdit;

  let api;
  if (devData?.isServer) {
    api = localApi;
  }
  else if (devData?.isOffline) {
    api = localApi;
  }
  else if (devData?.isClient) {
    api = serverApi;
  }


  const cart = tabData[selectedTab].cart;
  let journalVoucher = tabData[selectedTab].journalVoucher;
  const componentRef = useRef();
  const printTriggerRef = useRef();



  const handleSubmit = async (isOrder) => {

     console.log('Delivery ID:');

    setLoadingEffect(true);

    let updatedJv = getJv(isOrder);
    let updatedCart = cart;
    let updatedTransactions = transactions;

    if (devData?.isOffline) {
      const offlineData = offlineJv(updatedJv, updatedCart, updatedTransactions);
      updatedJv = offlineData.updatedJv;
      updatedCart = offlineData.updatedCart;
      updatedTransactions = offlineData.updatedTransactions;
    }

    const data = {
      userId: userData.id,
      sessionId,
      jvId: jvId,
      journalVoucher: updatedJv,
      cart: updatedCart,
      transactions: updatedTransactions,
      charges: [],
      isOffline: devData?.isOffline,
      saveCustomerPrice,
    }

    

    const operation = isEdit ? 'edit' : 'add';
    try {
      let res = await api.post(`journalVoucher/${operation}`, data);

      if (res.data.status) {
        toast.success(res.data.message);
        if (isEdit) {
          refreshTableFunction();
        }
        closeModal();



        // Get account and delivery from updatedJv instead of res.data
        const accountPrint = res?.data?.account;
        if (accountPrint) {
          const isCash = updatedJv.paymentType == 'cash';
          const newBalance = isCash ? accountPrint?.balance : parseFloat(accountPrint.balance) + parseFloat(updatedJv.totalCredit);
          const secondaryNewBalance = isCash ? accountPrint?.secondaryBalance : parseFloat(accountPrint.secondaryBalance) + parseFloat(updatedJv.secondaryTotalCredit);
          accountPrint.newBalance = newBalance;
          accountPrint.secondaryNewBalance = secondaryNewBalance;
        }

        const deliveryPrint = updatedJv.deliveryId ? deliveryData.find(delivery => delivery.id === updatedJv.deliveryId) : null;

        console.log('Delivery ID:', updatedJv.deliveryId);
          console.log('Delivery Data:', deliveryData);
          console.log('Found Delivery:', deliveryPrint);   
  

   

        const companyPrint = updatedJv.companyId ?
          companyData.find(company => company.id === updatedJv.companyId) :
          null;


        const printData = {
          cart: cart || [],
          invoiceId: res.data?.jvId || jvId,
          company: companyPrint,
          account: accountPrint,
          delivery: deliveryPrint,
          userName: userData.name,
          vatAmount: totalVatAmount,
          journalVoucher: updatedJv,
          discountPercentage: updatedJv.discountPercentage,
          currency: selectedCurrency,
          settingData: settingData,
          ratedTotalPrice: ratedTotalPrice,
          ratedSymbol: ratedSymbol,  
          isUsingMainCurrency,
        }
        console.log('Final updatedJv before print:', updatedJv);
        printInvoice(printData);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Failed Contact Support");
      console.log(error)
    } finally {
      setLoadingEffect(false);
    }
  }


  const getJv = (isOrder) => {

    const updatedJv = { ...journalVoucher }
    const isDebit = updatedJv.isDebit;

    updatedJv.isOrder = isOrder;
    if (!isEdit) {
      updatedJv.date = today;
    }
    jvCost = rateToMainCurrency(selectedCurrency, jvCost);
    jvProfit = rateToMainCurrency(selectedCurrency, jvProfit);

    const discountAmount = rateToMainCurrency(selectedCurrency, totalDiscounts);
    const secondaryDiscountAmount = rateMainToSecondaryCurrency(discountAmount);

    const secondaryJvCost = rateMainToSecondaryCurrency(jvCost);
    const secondaryJvProfit = rateMainToSecondaryCurrency(jvProfit);


    updatedJv.cost = jvCost;
    updatedJv.profit = jvProfit;

    updatedJv.secondaryCost = secondaryJvCost;
    updatedJv.secondaryProfit = secondaryJvProfit;

    updatedJv.discountAmount = discountAmount;
    updatedJv.secondaryDiscountAmount = secondaryDiscountAmount;

    const totalDebit = rateToMainCurrency(selectedCurrency, totalPrice);
    const totalCredit = rateToMainCurrency(selectedCurrency, totalPrice);

    const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
    const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);


    updatedJv.debit = totalPrice;
    updatedJv.credit = totalPrice;

    updatedJv.totalDebit = totalCredit;
    updatedJv.totalCredit = totalCredit;

    updatedJv.secondaryTotalDebit = secondaryTotalDebit;
    updatedJv.secondaryTotalCredit = secondaryTotalCredit;

    let jvType;
    if (isDebit) {
      if (!isOrder) {
        jvType = 'PosReturn';
      } else {
        jvType = 'PosReturnOrder';
      }
    } else {
      if (!isOrder) {
        jvType = 'PosSale';
      } else {
        jvType = 'PosSaleOrder';
      }
    }
    updatedJv.type = jvType;
    updatedJv.details = details;

    return updatedJv
  }

  const offlineJv = (updatedJv, cart, transactions) => {

    // Jorunal Voucher
    updatedJv.offlineCreatedBy = updatedJv.createdBy;
    delete updatedJv.createdBy;

    updatedJv.offlineYearId = updatedJv.yearId;
    delete updatedJv.yearId;

    updatedJv.offlineCompanyId = updatedJv.companyId;
    delete updatedJv.companyId;

    updatedJv.offlineBranchId = updatedJv.branchId;
    delete updatedJv.branchId;

    updatedJv.offlineProjectId = updatedJv.projectId;
    delete updatedJv.projectId;

    updatedJv.offlineWarehouseId = updatedJv.warehouseId;
    delete updatedJv.warehouseId;

    updatedJv.offlineTransferWarehouseId = updatedJv.transferWarehouseId;
    delete updatedJv.transferWarehouseId;

    updatedJv.offlineCurrencyId = updatedJv.currencyId;
    delete updatedJv.currencyId;

    updatedJv.offlineDeletedById = updatedJv.deletedBy;
    delete updatedJv.deletedBy;

    updatedJv.offlineSessionId = updatedJv.sessionId;
    delete updatedJv.sessionId;

    updatedJv.offlineAccountId = updatedJv.accountId;
    delete updatedJv.accountId;

    updatedJv.offlineSecondaryAccountId = updatedJv.secondaryAccountId;
    delete updatedJv.secondaryAccountId;

    updatedJv.offlineDeliveryId = updatedJv.deliveryId;
    delete updatedJv.deliveryId;

    // change Transactoin
    const updatedTransactions = transactions.map((item) => {
      let newItem = { ...item };

      newItem.offlineAccountId = newItem.accountId;
      delete newItem.accountId;

      newItem.offlineCurrencyId = newItem.currencyId;
      delete newItem.currencyId;

      newItem.offlineWarehouseId = newItem.warehouseId;
      delete newItem.warehouseId;

      return newItem;
    });

    // change Cart
    const updatedCart = cart.map((item) => {
      let newItem = { ...item };
      newItem.offlineProductId = newItem.productId;
      delete newItem.productId;
      return newItem;
    });

    return {
      updatedJv,
      updatedCart,
      updatedTransactions,
    };
  }

  const closeModal = () => {
    resetJournalVoucher(selectedTab);
    toggleModal();
    if (isEdit) {
      closePos()
    };
  }


  const printInvoice = (printData) => {
    if (printData && Object.keys(printData).length > 0 && isPrinting) {
      print(printData);
    }
  }



  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static' className='Delete_modal'>
      <Modal.Header style={{ background: "#1d7790" }} closeButton>
        <Modal.Title className="arabicText" style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="arabicText">

        <Row style={{ textAlign: 'center' }}>


          <span style={{ fontWeight: 'bold', fontSize: '30px' }}> Net Total :  {numberFormatter(totalPrice)} </span>

        </Row>

        <Row className='mb-3'>
          <Col>
            <Form.Control as="textarea" value={details} onChange={e => setDetails(e.target.value)} autoFocus rows={2} />
          </Col>
        </Row>

        {settingData.useCustomerPrice &&
          <Row className='mb-3'>
            <Col md={2}>
            </Col>
            <Col md={5}>
              <Form.Label>Save Customer Price</Form.Label>
            </Col>
            <Col>
              <Switch style={{ backgroundColor: saveCustomerPrice ? '#23576a' : '#bebfbe' }}
                checked={saveCustomerPrice}
                onChange={(e) => setSaveCustomerPrice(e)} />
            </Col>
          </Row>
        }

        {settingData.moneyExchange && (
          <Exchange
            finalNetTotal={totalPrice}
            selectedCurrency={selectedCurrency}
          />
        )}

        <Divider />


        <Row>
          <Col>
            <Button
              type="button"
              loading={loadingEffect}
              style={{ height: '80px', width: '100%', backgroundColor: '#b7e3f2', fontWeight: 'bold' }}
              className="btn btn-lg"
              onClick={() => handleSubmit(true)} >
              Order
            </Button>
          </Col>

          {journalVoucher.paymentType == 'cash' &&
            <Col>
              <Button
                type="button"
                loading={loadingEffect}
                style={{ height: '80px', width: '100%', backgroundColor: '#a4c436', fontWeight: 'bold' }}
                className="btn btn-lg"
                onClick={() => handleSubmit(false)} >
                Cash
              </Button>
            </Col>
          }

          {journalVoucher.paymentType == 'onAccount' &&
            <Col>
              <Button
                type="button"
                loading={loadingEffect}
                style={{ height: '80px', width: '100%', backgroundColor: '#eb5355', fontWeight: 'bold' }}
                className="btn btn-lg"
                onClick={() => handleSubmit(false)} >
                Credit
              </Button>
            </Col>
          }

        </Row>






      </Modal.Body>


    </Modal>
  );
}

export default PayCashModal;
